"use client"

import "./Header.css"

function Header() {
  return (
    <header className="app-header">
      <div className="header-container">
        <div className="left-section">
          <img src="/apollo-logo.png" alt="Apollo Hospitals Logo" className="apollo-logo" />
        </div>

        <div className="center-section">
          <h1 className="clinical-ai-title">Clinical AI</h1>
        </div>

        <div className="right-section">
          <img src="/ai-labs.png" alt="AI Labs Logo" className="ai-labs-logo" />
        </div>
      </div>
    </header>
  )
}

export default Header
